import { createAsyncThunk } from '@reduxjs/toolkit';
import { errorGlobal, successGlobal } from '../reducers/notifications';
import { getAuthHeader } from '../../utils/tools';
import axios from 'axios';

axios.defaults.headers.post['Content-Type'] = 'application/json';

// Fetch containers
export const fetchContainers = createAsyncThunk(
    'branch/fetchContainers',
    async(currentBranch, {dispatch}) => {
        try {
            const request = await axios.get(`/api/container/`, {
                    params: { branchId: currentBranch },
                    ...getAuthHeader()
                },
            );
            return request.data;
        } catch(error) {
            dispatch(errorGlobal('Nádobu sa nepodarilo načítať.'));
            throw error;
        }
    }
);

// Edit container
export const editContainer = createAsyncThunk(
    'branch/editContainers',
    async(data, {dispatch}) => {
        try {
            const { branchId, container, newContainer } = data;
            const request = await axios.patch(`/api/container/edit`, 
                { 
                    branchId,
                    container,
                    newContainer 
                },
                getAuthHeader()
            );

            dispatch(successGlobal('Nádoba bola úspešne upravená.'));
            return request.data;

        } catch(error) {
            dispatch(errorGlobal('Nádobu sa nepodarilo upraviť.'));
            throw error;
        }
    }
);

// Add container
export const addContainer = createAsyncThunk(
    'branch/addContainers',
    async(data, {dispatch}) => {
        try {
            const { branchId, container } = data;
            const request = await axios.post(`/api/container/create`, 
                { 
                    branchId,
                    container,
                },
                getAuthHeader()
            );

            dispatch(successGlobal('Nádoba bola úspešne vytvorená.'));
            return request.data;

        } catch(error) {
            dispatch(errorGlobal('Nádobu sa nepodarilo vytvoriť.'));
            throw error;
        }
    }
);

// Check if container exists in branch
export const checkContainerExists = createAsyncThunk(
    'branch/checkContainerExists',
    async({ branchId, container}, { rejectWithValue } ) => {
        try {

            const response = await axios.post(`/api/container/check-container`,
                {
                    branchId,
                    container
                },
                getAuthHeader()
            );

            return response.data.exists;

        } catch(error) {
            return rejectWithValue(error.response.data);
        }
    }
);

// Delete container
export const deleteContainer = createAsyncThunk(
    'branch/deleteContainer',
async({branchId, container}, { dispatch } ) => {
        try {
            const request = await axios.delete(`/api/container/delete`, {
                params: {
                        branchId,
                        container
                    },
                    ...getAuthHeader()
                }
            );
            
            dispatch(successGlobal('Nádoba bola úspešne vymazaná.'));
            return request.data;

        } catch(error) {
            dispatch(errorGlobal('Nádobu sa nepodarilo vymazať.'));
            throw error;
        }
    }
);